import type { FC, ReactNode } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const attributePillVariants = cva(
  "inline-flex items-center justify-center gap-8 rounded-circle border bg-neutral-white whitespace-nowrap text-neutral-black",
  {
    variants: {
      tone: {
        ice: "border-tone-ice",
        rose: "border-tone-rose",
      },
      size: {
        s: "px-8 py-4 text-14",
        m: "px-16 py-8 text-14",
      },
    },
    defaultVariants: {
      tone: "ice",
      size: "m",
    },
  },
);

type AttributePillProps = VariantProps<typeof attributePillVariants> & {
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
};

export const AttributePill: FC<AttributePillProps> = ({ tone, size, icon, children, className }) => (
  <span className={cn(attributePillVariants({ tone, size }), className)}>
    {icon && <span className="size-18 shrink-0">{icon}</span>}
    {children}
  </span>
);
